export const systemAdmin = {
  title: 'System admin',
  box: {
    users: {
      title: "User management",
      description: "User accounts, permissions and roles management",
      link: "User management"
    },
    organizations: {
      title: "Organization management",
      description: "Organizations, user accounts, permissions and roles management",
      link: "Organization management"
    },
    workpages: {
      title: "Workpage management",
      description: "Workpages, user accounts, permissions and roles management",
      link: "Workpage management"
    },
    workPageTemplates: {
      title: "Workpage templates management",
      description: "Workpage templates, user accounts, permissions and roles management",
      link: "Workpage templates management"
    },
  },
  messages: {
    user: {
      failedToLoad: 'Failed to load users',
      createdSuccess: 'User created successfully',
      createdError: 'Failed to create user',
      updatedSuccess: 'User updated successfully',
      updatedError: 'Failed to update user',
      deletedSuccess: 'User deleted successfully',
      deletedError: 'Failed to delete user',
      confirmTitle: 'User deletion',
      deleteQuestion: 'Are you sure you want to delete this user?',
      deleteWarning: 'This action cannot be undone.'
    }
  },
  users: {
    title: 'Users',
    addUser: 'Add user',
    deleteUser: 'Delete user',
    noName: 'Anonymous',
    never: 'Never',
    editUser: 'Edit user',
    fields: {
      name: 'Name',
      email: 'Email',
      role: 'Role',
      created: 'Created',
      lastLogin: 'Last Login',
      user: 'User',
      actions: 'Actions'
    },
    roles: {
      super_admin: 'Super admin',
      admin: 'Admin',
      user: 'User'
    },
    placeholders: {
      name: 'Name',
      email: 'Email',
      role: 'Role',
    },
  }
}
